import type { FilterControl, TextControl } from '../../../../../types/filterControl';
import { NoddiInput } from '../../../../Inputs/NoddiInput';
import { useDebouncedFilterInput } from './useDebouncedFilterInput';

export const TextInputFilter = ({
  control,
  renderFilterTitle
}: {
  control: TextControl;
  renderFilterTitle: (control: FilterControl) => React.ReactNode;
}) => {
  const { localValue, setLocalValue } = useDebouncedFilterInput(
    control.value,
    control.onChange,
    (raw) => (raw.trim() === '' ? null : raw.trim()),
    (value) => value ?? ''
  );

  return (
    <div className='min-w-0'>
      {renderFilterTitle(control)}
      <NoddiInput
        type='text'
        placeholder={control.placeholder ?? 'Enter text'}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        className='min-w-0'
      />
    </div>
  );
};
